import { TechDocWizardPage } from '../containers/pages';
import {
  ALLETRAMP_VIDEO_URL,
  HPE_GREENLAKE_DEDICATED_PLATFORM,
  PRODUCT_ID_BAAS,
} from '../constants';
import { gettingStarted } from './alletraMPPagesConfigComm';
import { TechDocPage } from '../containers/pages';
const physicalInstallPath = '/physical-install/';
const factoryCablePath = `${physicalInstallPath}cable/`;
const factoryUnboxPath = `${physicalInstallPath}unbox/`;
const softwareConfigPath = '/software-config/';
export const pagesConfig = [
  ...gettingStarted(PRODUCT_ID_BAAS, HPE_GREENLAKE_DEDICATED_PLATFORM),
  {
    path: physicalInstallPath,
    menuText: 'physicalInstallation',
    exact: true,
    redirectTo: factoryUnboxPath,
    submenuItems: [
      {
        path: factoryUnboxPath,
        menuText: 'unbox',
        exact: true,
        redirectTo: `${factoryUnboxPath}1`,
      },
      {
        path: `${factoryUnboxPath}:step`,
        exact: true,
        component: TechDocWizardPage,
        pageName: 'unbox',
        pageProps: {
          steps: [
            {
              videoUrl: ALLETRAMP_VIDEO_URL.FACTORY_UNBOX_STEP1,
              steptitle: 'Unbox Array',
            },
            {
              videoUrl: ALLETRAMP_VIDEO_URL.FACTORY_UNBOX_STEP2,
              steptitle: 'Remove Array From Pallet',
            },
            {
              videoUrl: ALLETRAMP_VIDEO_URL.FACTORY_UNBOX_STEP3,
              steptitle: 'Stabilize the Rack',
            },
          ],
        },
      },
      {
        path: factoryCablePath,
        menuText: 'cable',
        exact: true,
        redirectTo: `${factoryCablePath}1`,
      },
      {
        path: `${factoryCablePath}:step`,
        exact: true,
        component: TechDocWizardPage,
        pageName: 'cable',
        pageProps: {
          steps: [
            {
              videoUrl: ALLETRAMP_VIDEO_URL.FIELD_CABLE_STEP1,
              steptitle: 'Cable Admin Ports',
            },
            {
              steptitle: 'Cable CDMs',
            },
            {
              videoUrl: ALLETRAMP_VIDEO_URL.FIELD_CABLE_DIRECTATTACHED_STEP2,
              steptitle: 'Cable Data Ports',
            },
            {
              videoUrl: ALLETRAMP_VIDEO_URL.FIELD_CABLE_STEP3,
              steptitle: 'Cable Hosts',
            },
            {
              videoUrl: ALLETRAMP_VIDEO_URL.FIELD_CABLE_STEP4,
              steptitle: 'Cable Power Supplies',
            },
          ],
        },
      },
      {
        path: `${physicalInstallPath}powerOn`,
        menuText: 'powerOn',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRAMP_VIDEO_URL.POWERUPANDINIT,
        },
      },
    ],
  },
  {
    path: `${softwareConfigPath}`,
    menuText: 'softwareConfig',
    exact: true,
    redirectTo: `${softwareConfigPath}importResources`,
    submenuItems: [
      {
        path: `${softwareConfigPath}importResources`,
        menuText: 'importResources',
        exact: true,
        component: TechDocPage,
      },
      {
        path: `${softwareConfigPath}arrayDiscForDedicatedPlatform`,
        menuText: 'arrayDiscForDedicatedPlatform',
        exact: true,
        component: TechDocPage,
      },
      {
        path: `${softwareConfigPath}connectArrayForDedicatedPlatform`,
        menuText: 'connectArrayForDedicatedPlatform',
        exact: true,
        component: TechDocPage,
      },
      {
        path: `${softwareConfigPath}arraySetupForDedicatedPlatform`,
        menuText: 'arraySetupForDedicatedPlatform',
        exact: true,
        component: TechDocPage,
      },

      {
        path: `${softwareConfigPath}completeSetup`,
        menuText: 'setupComplete',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
    ],
  },
];
